import { connect } from 'react-redux';
import { Nav } from './nav';

const mapStateToProps = (state) => {
  return {
    currentUser: state.user.currentUser
  };
};

export default connect(mapStateToProps)(Nav);